// Target for Alpha -> 75-80% of all cards PER DECK WORKING
// TOLERANCE MET. Anything after this is gravy. Main important piece is
// to finish up the summit resolution screen and we're DONE!!

// TODO for any cards that are WON'T DO, just dupe some random cards so we reach 69 cards. Tee hee fun times
export const blackListSpringSummer = [
	// Award
	4,
	5,
	6,
	// Contract
	9, // antiAerosolMusical
	14, //
	23, // ambiguousPatent
	27, // freezingPoint
	30, // lowestBidder

	// Equipment
	31,
	32,
	37,
	38,
	39,
	// Event
	48,
	49,
];
// memberberry, add 100 to get the in system id.
export const blackListFallWinter: number[] = [
	// Award
	10,
	// Contract
	20,

	// Equipment
	36, // FARM OF ANIMALS
	39, // WON'T DO - ENERGY LEECH
	40, // WON'T DO - ENERGY LEECH
	// 41, // LATER - MULLIGAN
	42, // WON'T DO - FAKE NEWS
	43, // WON'T DO - ALTERNATIVE FACTS

	// Event
	// 44, // Doesn't enable decision but whatevs - SPARE CALCULATOR BATTERIES
	46,
	47,
	50,
	51,
	// 53, Good enough for now, steals first equipment not one at random but thats kinda random anyway
	61,
	62,
	63,
	64,
	65,
];

export const blackListFallWinterOffset = blackListFallWinter.map((e) => {
	return e + 100;
});

export const blackListNews: number[] = [9, 14, 17, 20, 22, 29];

export const blackListSummit: number[] = [6, 7, 15, 16, 17]; // all...most?

/*
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    18,
    19
*/
